// extracted by mini-css-extract-plugin
module.exports = {"glacierWaveTreaserPC":"treaser_glacierWaveTreaserPC__Co0df"};